
import { PolicyBuyerSchedule } from "../../../api/policy";

export class PolicyBuyersCsvParser {
    selectedFile = null;

    constructor(file) {
        this.selectedFile = file;
    }

    parse(): Promise<PolicyBuyerSchedule[]> {
        return new Promise<PolicyBuyerSchedule[]>(resolve => {
            const reader = new FileReader();
            reader.readAsText(this.selectedFile);

            reader.onload = () => {
                const csvData = reader.result;
                const csvRecordsArray = (csvData as string).split(/\r\n|\n/);

                const headersRow = this.getHeaderArray(csvRecordsArray);

                var dataRows = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
                resolve(dataRows);
            };
        });

    }

    getHeaderArray(csvRecordsArr: any) {
        const headers = (csvRecordsArr[0] as string).split(',');
        const headerArray = [];
        for (const header of headers) {
            headerArray.push(header);
        }
        return headerArray;
    }

    getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
        const result = [];

        for (let i = 1; i < csvRecordsArray.length; i++) {
            const currentRecord = this.parseCsv(csvRecordsArray[i])[0];
            if (currentRecord.length === headerLength) {
                const buyer: PolicyBuyerSchedule = new PolicyBuyerSchedule();
                buyer.buyerName = currentRecord[0].trim();
                buyer.buyerDUNS = currentRecord[1].trim();
                buyer.obligor.address.countryCode = currentRecord[2].trim();
                buyer.maxCreditLimit = tryParseFloat(currentRecord[3].trim());
                buyer.maxPaymentTerms = currentRecord[4].trim();
                buyer.indemnity = tryParseFloat(currentRecord[5].trim());
                buyer.premiumRate = tryParseFloat(currentRecord[6].trim());
                buyer.estUtilization = tryParseFloat(currentRecord[7].trim());
                buyer.attachmentPeriodStartDate = tryParseDate(currentRecord[8].trim());
                buyer.attachmentPeriod = currentRecord[9].trim();
                buyer.seller = currentRecord[10].trim();
                buyer.descriptionOfGoods = currentRecord[11].trim();
                buyer.hasPastDueHistory = currentRecord[12].trim().toLowerCase() === 'yes' ? true : false;
                buyer.pastDueDescription = '';
                buyer.buyerSpecialConditions = currentRecord[13].trim().toLowerCase() === 'yes' ? true : false;
                buyer.specialConditionDescription = '';
                buyer.minimumPremium = tryParseFloat(currentRecord[14].trim());
                buyer.depositPremium = tryParseFloat(currentRecord[15].trim());
                buyer.isCancellable = currentRecord[16].trim().toLowerCase() === 'yes' ? true : false;
                buyer.limitCurrency = currentRecord[17].trim();
                buyer.state = currentRecord[18].trim();
                result.push(buyer);
            }
        }
        return result.filter(buyer => this.isValidImported(buyer));
    }

    parseCsv(data: any) {
        const fieldSep = ',';
        const newLine = '\n';
        const nSep = '\x1D';
        const qSep = '\x1E';
        const cSep = '\x1F';
        const nSepRe = new RegExp(nSep, 'g');
        const qSepRe = new RegExp(qSep, 'g');
        const cSepRe = new RegExp(cSep, 'g');
        const fieldRe = new RegExp('(?<=(^|[' + fieldSep + '\\n]))"(|[\\s\\S]+?(?<![^"]"))"(?=($|[' + fieldSep + '\\n]))', 'g');
        const grid: any = [];
        data.replace(/\r/g, '').replace(/\n+$/, '').replace(fieldRe, (match: any, p1: any, p2: any) => {
            return p2.replace(/\n/g, nSep).replace(/""/g, qSep).replace(/,/g, cSep);
        }).split(/\n/).forEach((line: any) => {
            const row = line.split(fieldSep).map((cell: any) => {
                return cell.replace(nSepRe, newLine).replace(qSepRe, '"').replace(cSepRe, ',');
            });
            grid.push(row);
        });
        return grid;
    }

    isValidImported(buyer: PolicyBuyerSchedule) {
        return hasValue(buyer.buyerName) &&
            hasValue(buyer.buyerDUNS) &&
            hasValue(buyer.obligor.address.countryCode) &&
            hasValue(buyer.maxCreditLimit) &&
            hasValue(buyer.state);
    }
}
const hasValue = (prop) => prop && prop != '';

const tryParseDate = (val: string) => {
    if (!val) return null;

    const parsed = new Date(val);
    return isNaN(parsed.getTime()) ? null : parsed;
}

function tryParseFloat(val: string): number {
    if (!val) return null;

    const parsed = parseFloat(val);
    return isNaN(parsed) ? null : parsed;
}

